import { Fragment, useContext, useEffect } from 'react';
import { ArrowLeftIcon } from '../../../assets/icons';
import logo from '../../../assets/icons/logo.svg';
import { useQuery } from '@apollo/client';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSession } from 'contexts';
import { GetOrganizationsDocument } from 'graphql/generated';
import { MegaphoneIcon, ChatBubbleLeftEllipsisIcon, QuestionMarkCircleIcon} from '@heroicons/react/24/outline';
import { AbilityContext } from 'contexts/AbilityContext';
import IntercomChat from 'components/IntercomChat/IntercomChat';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function BarTop(props) {
  const location = useLocation();
  const href = useLocation().pathname;
  const announcementSelected = href.includes("/announcements");
  const isDev = process.env.REACT_APP_APP_MODE !== 'production';
  const ability = useContext(AbilityContext);
  const craftCheck = props.context == null || !location.pathname.includes("/aircraft") || Object.keys(props.context).length === 0;

  const { organizationId, setOrganizationId, user, organizationType } = useSession();
  const { data: { organizations } = { organizations: [] } } = useQuery(GetOrganizationsDocument, { variables: { where: { userOrganizationProfiles: { 
    some: { user: { is:{ id: { equals: user?.id } } } } 
   } } } });
 
  useEffect(() => {
    if (!organizationId && organizations && organizations.length) {
      setOrganizationId(organizations[0].id);
    }
  }, [organizationId, organizations, setOrganizationId]);

  const altNav = props?.mobileExtraNav?.filter((nav) => {
    if(ability.can(nav.action, nav.subject) || !nav.action) return true;
    return false;
  });
  return (
    <>
      <div className="flex fixed flex-col top-0 w-screen h-14 md:hidden z-[9]">
      {/* Top Bar Mobile */}
        <div className="flex justify-center items-center px-6 h-14 text-brand shadow shadow-blue topbar-bg z-[100] shadow-2xl border-b border-slate-300">
          <Link to="/crafts"><img src={logo} className="h-6" alt=""/></Link>
          {!craftCheck && <Link className="absolute left-4 pointer-events-auto" to={location.pathname === "/aircraft"?"/crafts":"/aircraft"}><ArrowLeftIcon className={`h-4.5 w-4.5`} aria-hidden="true" /></Link>}
          <div className="flex gap-1 absolute right-3">
            <IntercomChat type="bar"/>
            <Link className="pointer-events-auto" to="/announcements"><MegaphoneIcon className="h-6 w-6"/></Link>
          </div>
        </div>
      </div>
      <div className="fixed top-0 mobile-bar h-32 w-screen md:hidden"></div>
    </>
  );
}
